import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BasketProvider } from "@/context/BasketContext";
import { Navbar } from "@/components/Navbar";
import { BasketDrawer } from "@/components/BasketDrawer";
import { Footer } from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Farms from "@/pages/Farms";
import FarmDetail from "@/pages/FarmDetail";
import OurStory from "@/pages/OurStory";
import Club from "@/pages/Club";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";

function App() {
    return (
        <BrowserRouter>
            <BasketProvider>
                <ScrollToTop />
                <Navbar />
                <BasketDrawer />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/farms" element={<Farms />} />
                    <Route path="/farms/:farmId" element={<FarmDetail />} />
                    <Route path="/our-story" element={<OurStory />} />
                    <Route path="/club" element={<Club />} />
                    <Route path="/journal" element={<Journal />} />
                    <Route path="/journal/:slug" element={<JournalArticle />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/order/:orderId" element={<OrderConfirmation />} />
                </Routes>
                <Footer />
                <Toaster position="bottom-right" theme="dark" />
            </BasketProvider>
        </BrowserRouter>
    );
}

export default App;
